import styled from "styled-components";
import { BorderSolidSlimBlack } from "./BorderSolidSlimBlack";
export const PaddedBorderSlimBlack = styled.div `
  ${BorderSolidSlimBlack};
  padding: 1rem;
`;
